import IconBack from '@bimser/icons/16/back';
import IconForward from '@bimser/icons/16/forward';
import IconHome from '@bimser/icons/16/home';
import classNames from 'classnames/bind';
import React, { JSX } from 'react';
import Style from '../assets/css/style.scss';
import IBreadCrumbNavigationClickEventArgs, {
	NavigationType
} from '../entities/IBreadCrumbNavigationClickEventArgs';
import IBreadCrumbNavigationProps from '../entities/IBreadCrumbNavigationProps';
const cx = classNames.bind(Style);

const BCNavigator = (props: IBreadCrumbNavigationProps) => {
	const [disable, setDisable] = React.useState(false);

	const generateTemplate = (): JSX.Element => {
		const { isLeftNavigatorDisable, isRightNavigatorDisable, visible } = props;

		if (!visible) {
			return null;
		}

		return (
			<div
				className={Style.breadCrumbNavigationContainer}
				style={props.navigatorStyle}
			>
				<div
					onClick={args => {
						onClick({ senderArgs: args, navigationType: NavigationType.Left });
					}}
					className={cx({
						navItem: true,
						left: true,
						disable: isLeftNavigatorDisable || disable
					})}
				>
					<IconBack />
				</div>
				<div
					onClick={args => {
						onClick({ senderArgs: args, navigationType: NavigationType.Right });
					}}
					className={cx({
						navItem: true,
						right: true,
						disable: isRightNavigatorDisable || disable
					})}
				>
					<IconForward />
				</div>
				<div
					onClick={args => {
						onClick({ senderArgs: args, navigationType: NavigationType.Home });
					}}
					className={[Style.navItem, Style.home].join(' ')}
				>
					<IconHome />
				</div>
			</div>
		);
	};

	const onClick = (args: IBreadCrumbNavigationClickEventArgs) => {
		if (!disable) {
			args.senderArgs.persist();
			args.senderArgs.stopPropagation();
			setDisable(true);
			props.onClick?.(args);
			setTimeout(() => {
				setDisable(false);
			}, 500);
		}
	};

	return generateTemplate();
};
export default BCNavigator;

export { IBreadCrumbNavigationClickEventArgs, IBreadCrumbNavigationProps };
